package com.qrkontaq.ui.admin

import androidx.compose.runtime.Composable
import com.qrkontaq.data.dto.WebAnalyticsDto
import com.qrkontaq.data.dto.WebNameCountDto

private val DONUT_COLORS = listOf("#34D399", "#E8A33D", "#7EE2BC", "#8699BE", "#FF6B5B", "#0F9D6E")

/**
 * SOURCES & GEO section: a world choropleth over visitor countries, top
 * countries/cities, referrers and UTM, plus device/browser donuts and browser
 * languages.
 */
@Composable
internal fun PlatformSourcesView(data: WebAnalyticsDto) {
    QpCard {
        QpTitle(PlatformT.anaMapTitle)
        QpWorldMap(data.countries)
    }

    QpTwoColumn(
        first = {
            QpCard {
                QpTitle(PlatformT.anaCountries)
                QpRankedList(
                    data.countries.map {
                        QpRank(countryName(it.name), it.count, flag = countryFlag(it.name))
                    },
                    trailingHint = PlatformT.anaColVisitors,
                )
            }
        },
        second = {
            QpCard {
                QpTitle(PlatformT.anaCities)
                QpRankedList(data.cities.map { QpRank(it.name, it.count) }, trailingHint = PlatformT.anaColVisitors)
            }
        },
    )

    QpTwoColumn(
        first = {
            QpCard {
                QpTitle(PlatformT.anaReferrers)
                QpRankedList(data.referrers.map { QpRank(it.name, it.count) }, emptyLabel = PlatformT.anaDirect)
            }
        },
        second = {
            QpCard {
                QpTitle(PlatformT.anaUtm)
                QpRankedList(data.utmSources.map { QpRank(it.name, it.count) })
            }
        },
    )

    QpTwoColumn(
        first = {
            QpCard {
                QpTitle(PlatformT.anaDevices)
                QpDonut(data.devices.toPairs(), DONUT_COLORS)
            }
        },
        second = {
            QpCard {
                QpTitle(PlatformT.anaBrowsers)
                QpDonut(data.browsers.toPairs(), DONUT_COLORS)
            }
        },
    )

    QpCard {
        QpTitle(PlatformT.anaLanguages)
        QpRankedList(data.languages.map { QpRank(it.name, it.count) })
    }
}

private fun List<WebNameCountDto>.toPairs(): List<Pair<String, Long>> = map { it.name to it.count }
